import React from 'react'
import { Button } from '@atd/rui-base.mui.button'
import { Stepper } from '@atd/rui-base.mui.stepper'
import { Step } from '@atd/rui-base.mui.step'
import { StepContent } from '@atd/rui-base.mui.step-content'
import { StepLabel } from '@atd/rui-base.mui.step-label'
import ValidatedTextField from '../commonComponents/validatedTextField'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'


import JobCreateBar from './dispatch/jobCreateBar'
import WorkorderGFF from '../gffManager/gffSelect'
import WorkorderRates from '../productManager/rateSelection'
import WorkorderScoutFeatures from '../scoutManager/scoutFeaturesUI'

import * as workorderActions from './workorderActions'
import './stepperStyles.css'
const styles = {
    defaultContentcolor: {
        backgroundColor: 'rgba(234,234,234, 0.25)',
    },
    iconStyle: {
        position: 'absolute',
        zIndex: 5,
        paddingLeft: '5px',
    },
}

const stepValues = {
    FIRST_STEP: 0,
    WO_NAME: 0,
    GFF_SELECTION: 1,
    PRODUCT_INFO: 2,
    SCOUT_FEATURES: 3,
    LAST_STEP: 3,
}

function mapStateToProps(state, ownProps) {
    return {
        selectedCompanyId: state.admin.selectedCompanyId,
        workorderName: state.workorder.workorderName,
        workorderUuid: state.workorder.workorderUuid,
        originationId: state.workorder.originationId,
        cloudJob: state.workorder.cloudJob,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators(workorderActions, dispatch),
    }
}

class WorkorderStepper extends React.Component {
    state = {
        stepIndex: stepValues.FIRST_STEP,
        visited: [stepValues.FIRST_STEP],
        saved: false,
    }

    componentDidMount() {
        if (!this.props.workorderUuid) {
            this.props.generateWorkorderUuid()
            if (this.props.existingWorkorderId) {
                this.setState({ visited: [
                    stepValues.WO_NAME,
                    stepValues.GFF_SELECTION,
                    stepValues.PRODUCT_INFO,
                    stepValues.SCOUT_FEATURES],
                })
                this.props.loadWorkorder(this.props.existingWorkorderId)
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        // When the selected company changes we need to reload base information or
        // clear the state to prevent the user from creating a workorder with information
        // they don't have access to, or does not belong together
        if (this.props.selectedCompanyId && this.props.selectedCompanyId !== prevProps.selectedCompanyId) {
            // Component is in create from template mode, reload the base workorder
            if (prevProps.existingWorkorderId && !prevState.saved) {
                this.props.generateWorkorderUuid()
                this.props.loadWorkorder(prevProps.existingWorkorderId)
            }
            // We are in basic workorder creation mode, clear selected information.
            else {
                this.clearState()
            }

            return
        }

        // Update which step is currently selected and which steps are visited
        const { stepIndex, visited } = this.state
        if (!visited.includes(stepIndex)) {
            this.setState({ visited: visited.concat(stepIndex) })
        }
    }

    handleNext = () => {
        const { stepIndex } = this.state
        if (stepIndex < stepValues.LAST_STEP) {
            this.setState({ stepIndex: stepIndex + 1 })
        }
    }

    handlePrev = () => {
        const { stepIndex } = this.state
        if (stepIndex > stepValues.FIRST_STEP) {
            this.setState({ stepIndex: stepIndex - 1 })
        }
    }

    onProcessed = () => {
        this.setState({saved: true})
    }
    clearState = () => {
        this.props.clearWorkorder()
        this.setState({
            stepIndex: stepValues.FIRST_STEP,
            visited: [stepValues.FIRST_STEP],
            errorMessage: '',
            saved: false,
        })
        window.scrollTo(0, 0)
    }
    createAnother = () => {
        this.setState({
            stepIndex: stepValues.FIRST_STEP,
            saved: false,
        })
        this.props.setWorkorderName('')
        this.props.generateWorkorderUuid()
        window.scrollTo(0, 0)
    }
    getDisabled = () => {
        return !this.props.selectedCompanyId
    }
    // Expand every step that contains a validation error and focus the first one.
    handleValidationFailed = (errorSteps) => {
        if (!errorSteps || errorSteps.length === 0) {
            return
        }
        this.setState(prevState => ({
            visited: [...new Set([...prevState.visited, ...errorSteps])],
            stepIndex: Math.min(...errorSteps),
        }))
    }
    getStepContent(stepIndex) {
        switch (stepIndex) {
            case stepValues.WO_NAME:
                return (
                    <div name="nameSectionContent" className="stepContent-Indented">
                        <ValidatedTextField
                            label="Job Name"
                            fullWidth
                            onChange={(event) => {
                                this.props.setWorkorderName(event.target.value)
                            }}
                            value={this.props.workorderName}
                            errorText={
                                (!this.props.workorderName && 'Required Field') ||
                                (this.props.workorderName.length > 32 && 'Max Length 32')
                            }
                            disabled={this.getDisabled() || this.state.saved}
                            name="nameEntry"
                        />
                    </div>
                )
            case stepValues.GFF_SELECTION:
                return (
                    <div name="gffSectionContent" className="stepContent-Indented">
                        <WorkorderGFF disabled={this.getDisabled() || this.state.saved}/>
                    </div>
                )
            case stepValues.PRODUCT_INFO:
                return (
                    <div name="productSectionContent" className="stepContent-Indented">
                        <WorkorderRates disabled={this.getDisabled() || this.state.saved}/>
                    </div>
                )
            case stepValues.SCOUT_FEATURES:
                return (
                    <div name="scoutSectionContent">
                        <WorkorderScoutFeatures disabled={this.getDisabled() || this.state.saved}/>
                    </div>
                )
            default:
                return '404: Page not found - stepper out of bounds'
        }
    }

    renderStep = (stepLabel, stepValue) => {
        return (
            <Step active={this.state.visited.includes(stepValue)} className="stepperStep" >
                <StepLabel
                    sx={{ '& .MuiStepLabel-iconContainer': styles.iconStyle }}
                    name={`${stepLabel}-Label`}
                    className="stepHeader"
                >
                    <Button variant="contained"
                        fullWidth
                        // TODO(APPS-2833 stepper MR): drop paddingLeft once Stepper migrates to v5 — compensates for absolute-positioned step icon
                        sx={{textAlign: 'left', paddingLeft: '40px', justifyContent: 'flex-start'}}
                        name={`${stepLabel}-StepButton`}
                        color={this.state.stepIndex === stepValue ? 'primary' : 'secondary'}
                        onClick={() => {
                            if (!this.state.visited.includes(stepValue)) {
                                this.setState({ stepIndex: stepValue })
                            }
                            else {
                                const newVisited = this.state.visited.filter(value => value !== stepValue)
                                this.setState(prevState => ({
                                    stepIndex: -1,
                                    visited: [...new Set([...newVisited])],
                                }))
                            }
                        }}
                        disabled={this.getDisabled() || this.state.saved}>{stepLabel}</Button>
                </StepLabel>
                <StepContent>{this.getStepContent(stepValue)}</StepContent>
            </Step>
        )
    }

    render() {
        if (this.props.existingWorkorderId && this.props.originationId == 'FC' && !this.props.cloudJob) {
            throw new Error('Cannot use an as-applied job as a template')
        }

        return (
            <div
                className="stepper"
                name="verticalStepper"
            >
                <Stepper
                    nonLinear
                    orientation="vertical"
                    style={styles.defaultContentcolor}
                >
                    {this.renderStep('Job Name', stepValues.WO_NAME)}
                    {this.renderStep('Grower, Farm, Field', stepValues.GFF_SELECTION)}
                    {this.renderStep('Product Config', stepValues.PRODUCT_INFO)}
                    {this.renderStep('Field Information', stepValues.SCOUT_FEATURES)}
                </Stepper>
                <JobCreateBar
                    saved={this.state.saved}
                    onSaved={this.onProcessed}
                    onTemplate={this.createAnother}
                    onReset={this.clearState}
                    onValidationFailed={this.handleValidationFailed}
                    disabled={this.getDisabled()}
                />
                <br/><br/>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkorderStepper)
